export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            关于我们
          </h2>
          <p className="text-foreground-500 text-xs tracking-widest mb-8">ABOUT US</p>

          <div className="bg-background-50 rounded-2xl p-8 md:p-12">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary-500/10 flex items-center justify-center">
              <i className="ri-movie-2-line text-3xl text-primary-500 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6">
              国内领先的免费在线观影平台
            </h3>
            <p className="text-foreground-700 leading-relaxed max-w-2xl mx-auto text-sm md:text-base">
              91电影创立于2024年，致力于为广大影迷提供优质、便捷的<strong>免费在线观看</strong>服务。平台聚合海量<strong>国产电影免费</strong>大片与热门<strong>免费视频</strong>资源，覆盖动作、喜剧、悬疑、科幻、爱情、纪录片等全类型影片。我们坚持每日更新片库，确保用户第一时间获取最新<strong>91电影免费播放</strong>内容，所有资源均支持高清流畅播放，无需注册登录，无需任何费用，真正做到让每个人都能<strong>免费在线观看</strong>好电影。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
              <span className="px-4 py-2 rounded-full bg-primary-500/10 text-primary-400 text-xs whitespace-nowrap">
                全类型覆盖
              </span>
              <span className="px-4 py-2 rounded-full bg-accent-500/10 text-accent-300 text-xs whitespace-nowrap">
                免费无广告
              </span>
              <span className="px-4 py-2 rounded-full bg-secondary-500/10 text-secondary-400 text-xs whitespace-nowrap">
                高清流畅
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}